module.exports = __webpack_public_path__ + "static/img/background2.cf9d8b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background2.png
// module id = YJiL
// module chunks = 13